import { render, staticRenderFns } from "./TableShareEdit.vue?vue&type=template&id=56e88210&scoped=true"
import script from "./TableShareEdit.vue?vue&type=script&lang=js"
export * from "./TableShareEdit.vue?vue&type=script&lang=js"
import style0 from "./TableShareEdit.vue?vue&type=style&index=0&id=56e88210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e88210",
  null
  
)

export default component.exports